module.exports = __webpack_public_path__ + "img/4_img.9900ef1e.png";